const PREVIEW_URL_REVOKE_DELAY_MS = 5 * 60 * 1000;

export interface PendingPdfPreview {
  previewWindow: Window | null;
}

const escapeHtml = (value: string): string =>
  value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");

const scheduleRevokeObjectUrl = (objectUrl: string): void => {
  window.setTimeout(() => {
    URL.revokeObjectURL(objectUrl);
  }, PREVIEW_URL_REVOKE_DELAY_MS);
};

const triggerBlobDownload = (objectUrl: string, fileName: string): void => {
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const openPendingPdfPreview = (
  title: string,
  loadingMessage: string,
): PendingPdfPreview => {
  const previewWindow = window.open("", "_blank");
  if (previewWindow == null) {
    return { previewWindow: null };
  }

  previewWindow.document.title = title;
  previewWindow.document.body.innerHTML = `
    <div style="font-family: sans-serif; padding: 24px; color: #13324b;">
      ${escapeHtml(loadingMessage)}
    </div>
  `;

  return { previewWindow };
};

export const closePendingPdfPreview = (
  pendingPreview: PendingPdfPreview,
): void => {
  if (
    pendingPreview.previewWindow == null ||
    pendingPreview.previewWindow.closed
  ) {
    return;
  }

  pendingPreview.previewWindow.close();
};

export const previewPdfAndDownload = (
  pendingPreview: PendingPdfPreview,
  blob: Blob,
  fileName: string,
): void => {
  const objectUrl = URL.createObjectURL(blob);

  if (
    pendingPreview.previewWindow != null &&
    !pendingPreview.previewWindow.closed
  ) {
    pendingPreview.previewWindow.document.title = fileName;
    pendingPreview.previewWindow.document.body.innerHTML = `
      <style>
        html, body {
          margin: 0;
          height: 100%;
          background: #111827;
        }

        iframe {
          width: 100%;
          height: 100%;
          border: 0;
        }
      </style>
      <iframe
        src="${objectUrl}#toolbar=1"
        title="${escapeHtml(fileName)}"
      ></iframe>
    `;
  }

  triggerBlobDownload(objectUrl, fileName);
  scheduleRevokeObjectUrl(objectUrl);
};
